export default __webpack_public_path__ + "static/media/skeleton-empty-tripple-string.0dd4487d.svg";